import React from 'react';
import { Hero } from '../components/home/Hero';
import { FeatureStrip } from '../components/home/FeatureStrip';
import { TheMaskSection } from '../components/home/TheMaskSection';
import { ScrollStory } from '../components/home/ScrollStory';
import { KitSection } from '../components/home/KitSection';
import { ProductDetails } from '../components/home/ProductDetails';
import { FaqSection } from '../components/home/FaqSection';
import { ClosingInvitation } from '../components/home/ClosingInvitation';
export function Home() {
  return <>
      <Hero data-id="element-424" data-mp="24j4rc9a29k4g" />
      <FeatureStrip data-id="element-425" data-mp="24ivabb6zunaw" />
      <TheMaskSection data-id="element-426" data-mp="29gdekoa2geck" />
      <ScrollStory data-id="element-427" data-mp="29f26wddi2mg6" />
      <KitSection data-id="element-428" data-mp="29ek5l2bzdi1e" />
      <ProductDetails data-id="element-429" data-mp="29i7zi2lc86gn" />
      <FaqSection data-id="element-430" data-mp="2dhgs344n5yam" />
      <ClosingInvitation data-id="element-431" data-mp="2dhyw4mxjpgt3" />
    </>;
}